/*
 * Copyright (c) 2023 NEXTwfl INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTwfl INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import {JSONable} from "@irian-ro/abstract-resource";
import {ValidIntervalModel} from "./valid-interval.model";
import {WorkflowConfigVoModel} from "./workflow-config-vo.model";

export class WorkflowListVoModel extends JSONable {
  uuid: string | null = null;
  name: string | null = null;
  defaultLabel: string | null = null;
  systemName: string | null = null;
  configuredForOwner: boolean | null = null;
  validInterval: ValidIntervalModel | null = null;
  workflowConfigVo: WorkflowConfigVoModel | null = null;

}
